import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { NotFoundSC, Card, Heading, SubHeading } from './NotFound.style';

import Config from 'app.config';

const NotFound = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('not_found.title');
    return () => {
      document.title = Config.appTitle;
    };
  });

  return (
    <NotFoundSC data-testid="not-found">
      <Card>
        <Heading data-testid="not-found-heading">{t('not_found.404')}</Heading>
        <SubHeading>{t('not_found.sub_heading')}</SubHeading>
      </Card>
    </NotFoundSC>
  );
};

export default NotFound;
